import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  Stack,
  alpha,
  useTheme,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";
import {
  PersonAdd as PersonAddIcon,
  CheckCircle as CheckCircleIcon,
  Email as EmailIcon,
  Sms as SmsIcon,
  Dashboard as DashboardIcon,
  Payment as PaymentIcon,
} from "@mui/icons-material";
import SupportLayout from "../Support/SupportLayout";

const BringCleaners = () => {
  const theme = useTheme();

  const benefits = [
    { icon: <PersonAddIcon />, title: "Keep Your Trusted Cleaner", desc: "Maintain the relationship you've already built" },
    { icon: <EmailIcon />, title: "Invite by Text or Email", desc: "Send an invitation directly through the platform" },
    { icon: <DashboardIcon />, title: "Organize Jobs Professionally", desc: "All your cleaning schedules in one dashboard" },
    { icon: <CheckCircleIcon />, title: "Track Completed Cleanings", desc: "Photo verification and completion reports" },
    { icon: <SmsIcon />, title: "Reduce Messy Communication", desc: "In-app messaging replaces endless texts" },
    { icon: <PaymentIcon />, title: "Simplify Payments", desc: "Automated payouts to your cleaner" },
  ];

  return (
    <SupportLayout
      title="Already Have a Cleaner? Bring Them to FreshSweeper"
      category="Services"
      subtitle="Invite your current cleaner by phone or email and manage schedules, payments, checklists, and turnovers in one place."
      breadcrumbs={[
        { label: "Services", link: "/services" },
        { label: "Bring Your Cleaner" },
      ]}
    >
      <Grid container spacing={4} sx={{ mb: 6 }}>
        {benefits.map((benefit, idx) => (
          <Grid item xs={12} md={4} key={idx}>
            <Card sx={{ height: "100%", p: 3, borderRadius: 3 }}>
              <Box sx={{ color: theme.palette.primary.main, mb: 2 }}>
                {React.cloneElement(benefit.icon, { sx: { fontSize: 40 } })}
              </Box>
              <Typography variant="h6" fontWeight="700" gutterBottom>
                {benefit.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {benefit.desc}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ textAlign: "center", py: 4 }}>
        <Button
          variant="contained"
          size="large"
          startIcon={<PersonAddIcon />}
          sx={{ borderRadius: "50px", px: 5, py: 1.5 }}
        >
          Invite My Cleaner
        </Button>
      </Box>
    </SupportLayout>
  );
};

export default BringCleaners;